import React, { Component } from "react";
import queryString from "query-string";
import { SCORMURL, ENV_NAME } from "util/constant";
import Helpers from "util/helpers";
import { api } from "api";

class Scormlink extends Component {
    state = {
        trainings: [],
        employeeCode: null,
        filteredData: []
    };

    async componentDidMount() {
        await this.fetchData();
    }

    async fetchData() {
        await api
            .get("/api/training/get-registered-trainings")
            .then((response) => {
                this.setState({
                    trainings: response.data.data.trainings,
                    filteredData: response.data.data.trainings,
                    employeeCode: response.data.data.employeeCode,
                });
                let query = queryString.parse(window.location.search);
                let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));

                const url = `${SCORMURL}/index?employeeCode=${this.state.employeeCode}&registeredTrainingId=${query.link}&langCode=${langCode}&env=${ENV_NAME}`;
                window.location.href = url;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.props.onProcessEnd();
            });
    }

    render() {
        return (<>

            <h1 style={{ textAlign: "center", margin: "220px", color: "#012f6d", fontWeight: "bold" }}> Scorm Redirect </h1>
        </>);
    }

}
export default Scormlink;